import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, ChangeDetectionStrategy, ViewChild, ViewChildren, ViewContainerRef, QueryList } from '@angular/core';
import { IEntityModel } from '@framework/interfaces/IEntityModel';
import { ViewType } from '@framework/core/Enums';
import { FormBuilderControl, IFormFieldGroup } from '@common/formbuilder/FormBuilderControl';
import { IdentityAuthService } from '../../../services/identity-auth/identity-auth.service';
import { IFieldGroup, IFieldDef } from '../../interfaces/IEntity';
import { MatDialog } from '@angular/material/dialog';
import { MfControlPopupComponent } from '../mf-control-popup/mf-control-popup.component';
import { NgForm, UntypedFormGroup, FormControl, ControlContainer } from '@angular/forms';
import { MfFormControlComponent } from '../mf-form-control/mf-form-control.component';
import { appStyleSettings } from '@shared/components/appSettings';

@Component({
  selector: 'app-mf-form-fields',
  templateUrl: './mf-form-fields.component.html',
  styleUrls: ['./mf-form-fields.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
  //changeDetection: ChangeDetectionStrategy.OnPush //Greatly helps with performance but have to be sure all change detection works or should be triggered itself when necessary https://netbasal.com/a-comprehensive-guide-to-angular-onpush-change-detection-strategy-5bac493074a4
})
export class MfFormFieldsComponent implements OnInit {
  public appStyleSettings = appStyleSettings;
  @Input() public htmlFormGroup: UntypedFormGroup = new UntypedFormGroup({});
  @ViewChild('htmlForm', { static: true }) htmlForm: NgForm;

  @ViewChildren('mfFormControls', { read: MfFormControlComponent }) mfFormControls: QueryList<MfFormControlComponent>;

  @Output() public htmlFormGroupChange = new EventEmitter();
  @Input() public initialLoadComplete: boolean;
  @Input() public parent: any;
  @Input() public formReadOnly: boolean = true;
  @Input() public groupsAreAccordions: boolean = false;
  @Input() public groupsAreTabs: boolean = false;
  @Input() public groupsAreMasterDetail: boolean = false;

  @Input() public set fieldGroups(value: Array<IFormFieldGroup>) {
    let self: MfFormFieldsComponent = this;

    if (!value) return;
    this._fieldGroups = value;
    if (!this._fieldGroups) return;
    this._fieldGroups.forEach(fg => {
      if (!fg.formFields && fg.fields) {
        fg.formFields = new Array<FormBuilderControl>();
        fg.fields.forEach(f => {
          fg.formFields.push(new FormBuilderControl().load(f))
        });
      }
     

    });
    if (this.fieldGroups && this.fieldGroups.length > 0)
      this.selectedMasterItem = this.fieldGroups[0];

  }
  @Input() public set formFields(value: Array<FormBuilderControl>) {
    if (this._formFields == value) return;
    this._formFields = value;
    let fieldGroups = new Array<IFieldGroup>();
    if (!this._formFields) return;
    this._formFields.forEach(f => {
      let groupName = f.fieldOptions.group ? f.fieldOptions.group : "mf-form-fields";
      if (!fieldGroups[groupName]) {
        fieldGroups[groupName] = { name: groupName, frame: groupName != 'mf-form-fields', formFields: new Array<FormBuilderControl>(), className: "col-xs-12 col-sm-12 col-md-12 col-lg-12" };
        fieldGroups.push(fieldGroups[groupName]);
      }
      fieldGroups[groupName].formFields.push(f);
    })
    this.fieldGroups = fieldGroups;
  }
  @Input() public small: boolean = false;
  @Input() public set data(value) {
    this._data = value;
    this.dataChange.emit(value);
  } public groupVisible(fg) {
    return fg.formFields.filter(ff => ff.show ? ff.show(this.data, this.authService, this) : true).length >0 ;
  }
  @Output() public dataChange = new EventEmitter();
  private _fieldGroups: Array<IFormFieldGroup>;
  private _formFields: Array<FormBuilderControl>;
  private _data: any = {};
  public formFieldClassName(formField) {
    return (formField.fieldOptions.className && {}.toString.call(formField.fieldOptions.className) === '[object Function]' ? formField.fieldOptions.className(this.data) : formField.className) + (formField.fieldOptions.enableNA ? " mfx-col-na" : "");
  }
  public get fieldGroups(): Array<IFormFieldGroup> { return this._fieldGroups; }
  public get formFields(): Array<FormBuilderControl> { return this._formFields; }
  public get data() { return this._data; }
  public self = this;
  public viewType = ViewType;

  constructor(private authService: IdentityAuthService, public cdr: ChangeDetectorRef, private dialogService?: MatDialog) { }
  public fieldValue(formField: FormBuilderControl) {
    return this._data[formField.field];
  }
  //public fieldHidden(formField) {
  //  return !formField.show(this.data, this.authService, this);
  //}
  public validateForm() {
    this.htmlFormGroup.markAllAsTouched();
  }
  public selectedMasterItem: any;
  private prevHidden: boolean = null;
  public fieldHidden(formField) {
    //if (!this.initialLoadComplete)
    //  return true;
    if (formField.controlType.viewType == ViewType.Popup) {
      var curValue = formField.show(this.data, this.authService, this);
      if (this.prevHidden == true && curValue) {
        let dialogRef = this.dialogService.open(MfControlPopupComponent, {
          data: { title: 'Test', formField: formField, actions: ['Test1', 'Test2'] },
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log(result);
        });
      }
      this.prevHidden = !curValue
      return true;
    }
    else return !formField.show(this.data, this.authService, this);

  }
  public fieldRequired(formField) {
    var anyRequired: any = formField.fieldOptions.required;
    if ({}.toString.call(anyRequired) === '[object Function]')
      return anyRequired(this.data, this.authService);
    else return anyRequired;
  }
  public ngOnInit() { }

  public getFormField(field, groupIndex?) {
    let formField = null;
    if (this.fieldGroups) {
      let fieldGroup = null;
      if (groupIndex == undefined || groupIndex == null) {
        fieldGroup = this.fieldGroups.find(fg => fg.formFields && fg.formFields.findIndex(ff => ff.field == field) > -1);
      }
      else {
        fieldGroup = this.fieldGroups[groupIndex]
      }
      if (fieldGroup && fieldGroup.formFields) {
        formField = fieldGroup.formFields.find(ff => ff.field == field)
      }
    }
    else if (this.formFields) formField = this.formFields.find(ff => ff.field == field);
    return formField ? formField : null;
  }

  public getFormControlInstance(fg: FormBuilderControl) {
    if (!this.mfFormControls)
      return;
    var filt = this.mfFormControls.toArray().filter(o => {
      return o.formField.bindingValue == fg.field
    })
    if (filt.length == 1)
      return filt[0];
    else return null;
  }
}
